import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "16",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "url(#a)",
  d: "M12.378 6.738c-.013.975.882 1.52 1.556 1.843.692.332.925.544.922.841-.005.455-.552.655-1.064.663-.894.014-1.413-.238-1.826-.428l-.321 1.484c.414.188 1.18.352 1.976.359 1.867 0 3.089-.908 3.095-2.316.007-1.787-2.508-1.886-2.491-2.684.006-.243.24-.5.754-.567.255-.033.957-.058 1.753.303l.313-1.435A4.8 4.8 0 0 0 15.38 4.5c-1.757 0-2.993.92-3.003 2.238m7.669-2.114a.81.81 0 0 0-.756.496l-2.667 6.275h1.865l.371-1.011h2.28l.216 1.01H23l-1.435-6.77zm.261 1.829.538 2.542h-1.474zm-10.192-1.83-1.47 6.772h1.777l1.47-6.771zm-2.63 0-1.85 4.61-.749-3.92a.825.825 0 0 0-.82-.69H1.042L1 4.82c.621.133 1.327.347 1.754.576.262.14.336.263.422.595l1.418 5.404h1.879l2.88-6.771z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("linearGradient", {
    id: "a",
    x1: "11.114",
    x2: "11.314",
    y1: "11.64",
    y2: "4.451",
    gradientUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("stop", { "stop-color": "#222357" }),
    /*#__PURE__*/_createElementVNode("stop", {
      offset: "1",
      "stop-color": "#254AA5"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }